const positive = value => /^[1-9]\d*$/.test(String(value));
const endpoints = {
  documento: "atendimentos/access/obterDocumentoHistorico",
  procedimento: "agendamentos/access/obterProcedimentoAgenda",
  contato: "contatosExternos/access/obter",
  configuracao: "configuracoes/access/buscarConfiguracaoMaster"
};
export async function lerHistorico(api, jwt, { recurso, dados, signal }) {
  if(!jwt.getToken() || !endpoints[recurso]) { throw new Error("Leitura indisponível. Confira a sessão e tente novamente."); }
  api.setHeader();
  const { data } = await api.postOnce(endpoints[recurso], dados, { signal, timeout: 120000 });
  if(!data || typeof data !== "object" || Array.isArray(data)) { throw new Error("Resposta inválida ao carregar o histórico."); }
  if(recurso === "documento" && (String(data.ID_DIVERSOS) !== String(dados.ID_DIVERSOS) || String(data.ID_PACIENTE) !== String(dados.ID_PACIENTE) || typeof data.ESPECIAL !== "string")) { throw new Error("O texto retornado não corresponde ao documento solicitado."); }
  if(recurso === "procedimento" && !positive(data.ID_AGENDA_EXAME)) { throw new Error("Não foi possível carregar o exame da imagem."); }
  if(recurso === "contato" && String(data.ID_CONTATO_EXTERNO) !== String(dados.ID_CONTATO_EXTERNO)) { throw new Error("Não foi possível carregar o contato externo."); }
  if(recurso === "configuracao" && !Object.prototype.hasOwnProperty.call(data, "CONTEUDO")) { throw new Error("Não foi possível carregar a configuração de liberação."); }
  return data;
}
export async function prepararLiberacaoImagem(vm, row, vigente, signal) {
  const ler = async (recurso, dados) => {
    const result = await vm.lerHistorico({ recurso, dados, signal });
    if(!vigente()) { throw new Error("Contexto alterado."); }
    return result;
  };
  const id = row.ID_AGENDA_EXAME_AUX || row.ID_AGENDA_EXAME;
  const agenda = id ? await ler("procedimento", { ID_AGENDA_EXAME: id }) : {};
  let option;
  if(agenda.ID_CONTATO_EXTERNO) {
    const contato = await ler("contato", { ID_CONTATO_EXTERNO: agenda.ID_CONTATO_EXTERNO, componente: "AtendimentoItem" });
    if(contato.LIBERAR_LAUDO == "1") { option = contato.LIBERAR_LAUDO_PACIENTE == "1" ? "0" : "1"; }
    else if(contato.LIBERAR_LAUDO_PACIENTE == "1") { option = "2"; }
  }
  if(option === undefined) {
    const config = await ler("configuracao", { CONTEUDO_NOME: "CONTEUDO", NIVEL: "4", OPERACAO: "C", USUARIO: vm.usuario,
      SISTEMA: "CLMADV", MODULO: "LAUDO", CAMPO: "LAUDO_LIBERACAO_MODO", CONTEUDO: "" });
    if(config.CONTEUDO !== "" && config.CONTEUDO != null) {
      if(!["1", "2", "3"].includes(String(config.CONTEUDO))) { throw new Error("Configuração de liberação inválida. Confira a opção cadastrada."); }
      option = String(Number(config.CONTEUDO) - 1);
    }
  }
  if(option === undefined) {
    const choice = await vm.$swal({ title: "Qual forma de liberação deseja utilizar?", input: "select", showCancelButton: true,
      inputOptions: { 0: "Quero liberar a imagem para o contato externo e para o paciente.", 1: "Quero liberar a imagem somente para o contato externo.", 2: "Quero liberar a imagem somente para o paciente." },
      inputPlaceholder: "Selecione a opção", inputValidator: value => !["0", "1", "2"].includes(String(value)) ? "Você precisa selecionar uma opção!" : undefined });
    if(!vigente() || !choice.isConfirmed) { return null; }
    option = String(choice.value);
  }
  if(!["0", "1", "2"].includes(option)) { throw new Error("Selecione uma forma de liberação válida."); }
  return { ID_AGENDA_EXAME: agenda.ID_AGENDA_EXAME || "", OPCAO_LIBERAR: option };
}

export function decodificarDocumento(documento) {
  const copy = { ...documento }, value = copy.ESPECIAL;
  if(value && /^(?:[0-9a-zA-Z+/]{4})*(?:[0-9a-zA-Z+/]{2}==|[0-9a-zA-Z+/]{3}=)?$/.test(value)) {
    try { copy.ESPECIAL = window.b64DecodeUnicode(value); }
    catch(error) { copy.ESPECIAL = atob(value); }
  }
  return copy;
}
const controls = new WeakMap();
export function textosHistorico(vm) {
  if(controls.has(vm)) { return controls.get(vm); }
  let current = null, generation = 0, closed = false;
  const context = () => JSON.stringify([vm.$route.fullPath, vm.$route.params.id, vm.atendimento.ID, vm.atendimento.TIPO]);
  const valid = req => !closed && current === req && req.generation === generation && req.context === context();
  function executar(row, action, editar = false) {
    if(closed || vm.acaoHistorico?.ocupada || vm.acaoHistorico?.pendente) { return Promise.resolve(false); }
    if(current) { return current.promise; }
    if(!positive(row.ID) || String(row.ID) !== String(vm.atendimento.ID) || (row.ID_PACIENTE && String(row.ID_PACIENTE) !== String(vm.$route.params.id))) { return Promise.resolve(false); }
    const req = { context: context(), generation, controller: new AbortController(), promise: null };
    current = req; vm.isLoading = true;
    req.promise = Promise.resolve().then(async () => {
      try {
        const raw = await vm.lerHistorico({ recurso: "documento", dados: { ID_DIVERSOS: row.ID, ID_PACIENTE: vm.$route.params.id }, signal: req.controller.signal });
        if(!valid(req)) { return false; }
        const doc = decodificarDocumento(raw);
        if(action === "copiar") {
          if(!doc.ESPECIAL) { throw new Error("O texto está vazio; nenhum conteúdo foi copiado."); }
          vm.emitter.emit("modificarTextoIncluindoPEP", doc);
        } else {
          vm.documento = doc;
          if(vm.permiteAlterarTexto() || editar) {
            if(doc.USUARIO_INCLUSAO === vm.usuario) { vm.atualizarSalvarTextoDiretamente(true); vm.$emit("alterarTexto", doc); }
            else { await vm.$swal({ icon: "warning", title: "Atenção!", text: "Esse texto não foi incluído pelo seu usuário, não será possível editá-lo." }); }
          } else if(!vm.$refs.modalDocumento.showModal) { await vm.$refs.modalDocumento.toggleModal(); }
        }
        return true;
      } catch(error) {
        if(valid(req)) { await vm.$swal({ icon: "warning", title: "Texto não carregado", text: "Não foi possível abrir ou copiar o texto. O conteúdo atual foi preservado; tente novamente." }); }
        return false;
      } finally {
        if(valid(req)) { vm.isLoading = false; current = null; }
      }
    });
    return req.promise;
  }
  const c = {
    abrir: (row, editar) => executar(row, "abrir", editar),
    copiar() {
      if(["DOCUMENTO", "RECEITUARIO"].includes(vm.atendimento.TIPO)) { return executar(vm.atendimento, "copiar"); }
      if(!closed) { vm.$emit("copiarAtendimento", vm.atendimento); } return Promise.resolve(true);
    },
    invalidar() { generation++; current?.controller.abort(); current = null; vm.isLoading = false; },
    destruir() { c.invalidar(); closed = true; }
  };
  controls.set(vm, c); return c;
}
